import { render, staticRenderFns } from "./memoryOptions.vue?vue&type=template&id=e735399e&scoped=true&"
import script from "./memoryOptions.vue?vue&type=script&lang=js&"
export * from "./memoryOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e735399e",
  null
  
)

export default component.exports